const listStyle = {
    item: {
        padding: '15px 0 7px',
        fontSize: 14
    }
};

export default listStyle;


// WEBPACK FOOTER //
// src/components/ui/list-style.js